import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "static-hero" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "static-body bg-gondola" }
const _hoisted_4 = {
  class: "container mw-1356",
  style: {"max-width":"860px"}
}
const _hoisted_5 = {
  key: 0,
  class: "text-center text-silver py-5"
}
const _hoisted_6 = {
  key: 1,
  class: "faq-list"
}
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarTwo = _resolveComponent("NavbarTwo")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NavbarTwo),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "top-title" }, "FAQ", -1)),
        _createElementVNode("h1", null, _toDisplayString(_ctx.c.heading || 'Frequently Asked Questions'), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.c.subheading || 'Everything you need to know about our service'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.items.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "No FAQs yet."))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: _normalizeClass(["faq-item", { open: _ctx.openIndex === i }])
                }, [
                  _createElementVNode("button", {
                    class: "faq-q",
                    onClick: ($event: any) => (_ctx.openIndex = _ctx.openIndex === i ? -1 : i)
                  }, [
                    _createElementVNode("span", null, _toDisplayString(item.question), 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.openIndex === i ? 'ti ti-minus' : 'ti ti-plus')
                    }, null, 2)
                  ], 8, _hoisted_7),
                  _withDirectives(_createElementVNode("div", { class: "faq-a" }, _toDisplayString(item.answer), 513), [
                    [_vShow, _ctx.openIndex === i]
                  ])
                ], 2))
              }), 128))
            ]))
      ])
    ]),
    _createVNode(_component_MainFooter),
    _createVNode(_component_CopyRight)
  ]))
}